import MuiBox, { type BoxProps } from '@mui/material/Box'
import type { CSSProperties, ElementType, ReactElement } from 'react'

type CustomProps = {
	flex?: boolean
	col?: boolean
	center?: boolean
	full?: boolean
	justify?: CSSProperties['justifyContent']
	align?: CSSProperties['alignItems']
}

// Polymorphic like MuiBox itself: passing `component='form'` types the rest of the
// props (e.g. `noValidate`, `onSubmit`) against HTMLFormElement instead of div.
interface BoxComponent {
	<RootComponent extends ElementType>(
		props: { component: RootComponent } & CustomProps & Omit<BoxProps<RootComponent>, 'flex' | 'component'>,
	): ReactElement | null
	(props: CustomProps & Omit<BoxProps, 'flex'>): ReactElement | null
}

export const Box: BoxComponent = ({ flex, col, center, full, justify, align, ...props }: CustomProps & Omit<BoxProps, 'flex'>) => (
	<MuiBox
		{...props}
		sx={{
			display: flex ? 'flex' : props.display,
			flexDirection: col ? 'column' : props.flexDirection,
			justifyContent: justify ?? (center ? 'center' : props.justifyContent),
			alignItems: align ?? (center ? 'center' : props.alignItems),
			w: full ? '100%' : undefined,
			h: full ? '100%' : undefined,
			...props.sx,
		}}
	/>
)
